
import { Card, Button, Progress } from "@nextui-org/react";
import { useCallback, useState, useEffect } from "react";
import useW3Machine from "../../../hooks/useW3Machine.js";
import { formatAmount } from "../../../utils/amount";
import { formatUnits } from "viem";
import { NumberCount } from "../../../components/NumberCount";

const Machine = ({ _index }) => {
    const [claiming, setClaiming] = useState(false)
    // console.log('_index', _index);
    const {value:item, onWithdrawW3 ,isLoading} = useW3Machine(_index);
    // console.log('item', item);
    return item && (
        <Card className="bg-gray-100 dark:bg-box p-6 rounded-xl shadow-xl mt-2" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
            <div className="flex gap-4 items-center">
                <div className="relative inline-block">
                    <img
                        src="/images/mining.png"
                        alt="SWAP矿机节点"
                        className="w-36 h-18 object-cover rounded-lg border border-yellow-600"
                    />
                    <span className="absolute top-2 left-2 text-white text-sm font-bold px-2 py-1 rounded">#
                        {Number(item.tokenId)}
                    </span>
                </div>

                <div className="flex-1 grid grid-cols-2 gap-4">
                    <div className="text-center">
                        <p className="text-gray-400 text-xs">剩余量</p>
                        <p className="text-button text-xs font-bold">{formatAmount(formatUnits(item.miningData[0][0] - item.miningData[0][1], 18))}</p>
                    </div>
                    <div className="text-center">
                        <p className="text-gray-400 text-xs">可领取</p>
                        <p className="text-button text-xs font-bold "><NumberCount value={parseFloat(formatAmount(formatUnits(item.miningData[0][5], 18)))} decimals={3} /></p>
                    </div>
                    <div className="text-center">
                        <p className="text-gray-400 text-xs">已领取</p>
                        <p className="text-button text-xs font-bold">{formatAmount(formatUnits(item.miningData[0][1], 18))}</p>
                    </div>
                    <Button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" disabled={isLoading} isLoading={isLoading} onPress={onWithdrawW3}>
                        领取
                    </Button>
                </div>
            </div>
        </Card>
    )
}
export default Machine;